import React, { useState, useRef, useEffect } from 'react';
import { AiOutlineMenu, AiOutlineClose, AiOutlinePlus, AiOutlineUser, AiOutlineTwitter, AiFillInstagram, AiTwotoneMail } from 'react-icons/ai';
import { FiLogOut } from 'react-icons/fi';
import { RiHomeFill } from 'react-icons/ri';
import {SiAboutdotme} from 'react-icons/si';
import { IoIosArrowForward } from 'react-icons/io';

import { googleLogout } from '@react-oauth/google';
import { NavLink, Link, Route, Routes, useNavigate } from 'react-router-dom';

import {Sidebar, UserProfile } from '../components';
import Prompts from './Prompts';
import { userQuery, searchCodeTableQuery } from '../utils/data';
import { client } from '../client';
import promptHavenLogo from '../assets/PromptHaven_Logo_Small.png';
import { fetchUser } from '../utils/fetchUser';
import Announcement from '../components/Announcement';
import promptHavenProfile from '../assets/PromptHavenProfile.png'


const Home = () => {
  const [toggleSidebar, setToggleSidebar] = useState(false)
  const [user, setUser] = useState(null);
  const [cat, setCat] = useState(null);
  const scrollRef = useRef(null);
  const userInfo = fetchUser();
  const navigate = useNavigate();
  
  useEffect(() => {
      const query = userQuery(userInfo?.sub);
      const categoryQuery = searchCodeTableQuery("Category");

      client.fetch(query)
        .then((data) => {
          setUser(data[0]);
        })

        client.fetch(categoryQuery)
      .then((data) => {
        setCat(data);
      })

  }, []);



  // useEffect(() => {
  //   scrollRef.current.scrollTo(0, 0);
  // });

  const [activeNav, setActiveNav] = useState();

  const logout = () => {
    localStorage.clear();
    navigate('/login');
  };
  

  return (
    <div className='flex flex-col'>
    <Announcement />
    <div className="navbar bg-base-100 sticky top-0 shadow-md z-20">
          <div className="flex-auto">
            <label htmlFor="my-drawer-2" className="btn btn-square btn-ghost drawer-button lg:hidden"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="inline-block w-5 h-5 stroke-current"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path></svg></label>
            <Link to="/" ><a className="btn btn-ghost normal-case text-xl hidden lg:flex" onClick={(e) => {setActiveNav('Home');}}>prompthaven.</a></Link>
          </div>
          <div className="flex-auto">
          <Link to="/" ><a className="btn btn-ghost normal-case text-xl lg:hidden" onClick={(e) => {setActiveNav('Home');}}>prompthaven.</a></Link>
          </div>
          <div className="flex-none">
          
            <div className="dropdown dropdown-end">
            
                <label tabIndex={0} className="btn btn-ghost btn-circle avatar">
                  <div className="w-10 rounded-full">
                    <img src={user?.image} />
                  </div>
                </label>
                <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-40">
                  <Link to="/create-prompt"><li key="create"><a><AiOutlinePlus/>Create</a></li></Link>
                  <Link to={`user-profile/${user?._id}`}><li key="profile"><a><AiOutlineUser/>Profile</a></li></Link>
                  <li key="logout"><a onClick={() => {
                            googleLogout();
                            localStorage.removeItem('user');
                            logout();
                          }}><FiLogOut color="red" />Logout</a></li>
                  </ul>
            </div>
          </div>
    </div>
    
  
    <div className="drawer drawer-mobile h-[calc(100vh-110px)] ">
      
      <input id="my-drawer-2" type="checkbox" className="drawer-toggle" />
      
      <div className="drawer-content flex flex-col bg-gray-100 ">

      
      

      <div className='flex bg-gray-100 md:flex-row flex-col transaction-height'>
        <div className='pb-2 flex-1 overflow-y-scroll hide-scrollbar' >
              <Routes>
                <Route path='/user-profile/:userId' element={<UserProfile />} />
                <Route path='/*' element={<Prompts user={user && user}/>} />
              </Routes> 
            </div>
        </div>

      </div> 

      <div className="drawer-side">
        <label htmlFor="my-drawer-2" className="drawer-overlay"></label> 
        <ul className="menu p-4 w-60 bg-base-100 text-base-content">
          <NavLink to={`/`}><li key="home"><a onClick={(e) => {setActiveNav('Home');}} className={`${activeNav === 'Home' ? "active" : ""}`}><RiHomeFill/> Home </a></li></NavLink>
          <li key="Separator1"></li>
          <li className="menu-title" key="Categories"><span>Categories</span></li>
          {cat && cat.slice(0, cat.length).map((category) => (
            <NavLink to={`/category/${category.name}`} key={category.name}> <li key="{category.name}"><a onClick={(e) => {setActiveNav(`${category.name}`);}} className={`${activeNav === `${category.name}` ? "active" : ""}`}>
                {category.name}
            </a></li></NavLink>
          ))}
          <li key="Separator2"></li>
          <label htmlFor="my-modal"><li key="about"><a><SiAboutdotme/> About </a></li></label>
      

        </ul>


       
        

      </div>

{/* Put this part before </body> tag */}
<input type="checkbox" id="my-modal" className="modal-toggle" />
<div className="modal">
  <div className="modal-box">
    <div className="avatar flex justify-center">
      <div className="w-24 mask mask-hexagon">
      <img src={promptHavenProfile} />
      </div>
    </div>
    <h3 className="font-bold text-lg text-center mt-2">Hi! My name is Taufiq.</h3>
    <p className="py-4 text-center">I love AI art. The complexity that AI can generate just from text itself blows my mind! Unfortunately, I could not find a place to share my wonderful prompts and greatest artwork. </p>
    <p className="text-center mb-4"> So... that's how <b>prompthaven.</b> was born.</p>
    <p className="text-center mb-4">Share those wonderful prompts that are waiting for the world to see and I hope you find what you are looking for while on your creative journey. Feel free to drop by anytime! Cheers 🎉</p>
    <p className='text-center'>
    <a href="https://twitter.com/taufiqfharhan" target="_blank" rel="noreferrer">
    <button className="btn btn-square btn-outline mr-4">
    <AiOutlineTwitter size={25}/>
    </button>
    </a>
    <a href="https://www.instagram.com/taufreak/" target="_blank" rel="noreferrer">
    <button className="btn btn-square btn-outline mr-4">
    <AiFillInstagram size={25}/>
    </button>
    </a>
    <a href="mailto:prompthaven@gmail.com" target="_blank" rel="noreferrer">
    <button className="btn btn-square btn-outline">
    <AiTwotoneMail size={25}/>
    </button>
    </a>
      </p>
    <div className="modal-action justify-center">
      <label htmlFor="my-modal" className="btn btn-circle btn-outline">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
      </label>
    </div>
  </div>
</div>




      

    </div>


  </div>
  )
}

/*
<HiMenu fontSize={40} className="cursor-pointer" onClick={() => setToggleSidebar(true)}/>



<div className='flex flex-col'>
        <Announcement />
      
      <div className='flex bg-gray-100 md:flex-row flex-col h-[calc(100vh-40px)] transaction-height duration-75 ease-out '>
          <div className='hidden md:flex h-[calc(100vh-40px)]  flex-initial'>
          <Sidebar user={user && user} />
          </div>
            <div className='flex md:hidden flex-row'>
              <div className='p-2 w-full flex flex-row justify-between items-center shadow-md'>
              
              <div className="flex-none">
                <button className="btn btn-square btn-ghost" onClick={() => setToggleSidebar(true)}>
                  <AiOutlineMenu fontSize={30}/>
                </button>
              </div>
              <Link to="/" >
                <img src={promptHavenLogo} alt="logo" className='w-10' />
              </Link>

              <div className="dropdown dropdown-end">
                <label tabIndex={0} className="btn btn-ghost btn-circle avatar">
                  <div className="w-10 rounded-full">
                    <img src={user?.image} />
                  </div>
                </label>
                <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-40">
                  <Link to="/create-prompt"><li><a><AiOutlinePlus/>Create</a></li></Link>
                  <Link to={`user-profile/${user?._id}`}><li><a><AiOutlineUser/>Profile</a></li></Link>
                  <li><a onClick={() => {
                            googleLogout();
                            localStorage.removeItem('user');
                            logout();
                          }}><FiLogOut color="red" />Logout</a></li>
                  </ul>
              </div>

              </div>
            {toggleSidebar && (
              <div className='fixed w-4/5 bg-white h-[calc(100vh-40px)] overflow-y-scroll hide-scrollbar shadow-md z-10 animate-slide-in'>
                <div className='absolute w-full flex justify-end items-center p-2'>
                  <AiOutlineClose fontSize={40} className='cursor-pointer' onClick={() => setToggleSidebar(false)} />
                </div>
                  <Sidebar user={user && user} closeToggle={setToggleSidebar}/>
              </div>
            )}
            </div>
          <div className='pb-2 flex-1 h-[calc(100vh-40px)]  overflow-y-scroll' ref={scrollRef}>
            
            <Routes>
              <Route path='/user-profile/:userId' element={<UserProfile />} />
              <Route path='/*' element={<Prompts user={user && user}/>} />
            </Routes>
            
          </div>
      </div>        

      </div>

      <Announcement />

                <div className="flex-auto">
            <Link to="/" >
                <img src={promptHavenLogo} alt="logo" className='w-10' />
            </Link>
          </div>

          <img src="https://placeimg.com/192/192/people" />
      
*/

export default Home